import styled from 'styled-components';

export const TooltipWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

export const IconWrapper = styled.span`
  display: inline-flex;
  line-height: 0;
`;

export const TooltipText = styled.div<{ color: string }>`
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  min-width: 17.5rem;
  max-width: 21.875rem;
  background-color: #555555f6;
  border: solid 0.0938rem ${(props) => props.color};
  color: #fff;
  text-align: start;
  border-radius: 0.375rem;
  padding: 0.3125rem;
  white-space: normal;
`;

export const LineBreak = styled.div`
  margin-top: 0.3125rem;
`;
